import { gql } from '@apollo/client';

export const GET_DECLARATION = gql`
  query getDeclaration($id: ID) {
    declaration: getDeclaration(id: $id) {
      id
      createdAt
      updatedAt

      published
      text
      title
      version

      createdBy {
        id
        firstName
        lastName
      }
      modifiedBy {
        id
        firstName
        lastName
      }
      portal {
        id
        name
      }
      organisation {
        id
      }
    }
  }
`;
